import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import OrderPage from '../views/OrderPage.vue'
import About from '../views/About.vue'
import Imprint from '../views/Imprint.vue'
import DataProtection from '../views/DataProtection.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/order/:vehicleId',
    name: 'OrderPage',
    component: OrderPage
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/imprint',
    name: 'Imprint',
    component: Imprint
  },
  {
    path: '/data',
    name: 'data',
    component: DataProtection
  },
  {
    path: '/swipe',
    name: 'Swipe',
    component: () => import(/* webpackChunkName: "swipe" */ '../views/Swipe.vue')
  },
  {
    path: '/comparison',
    name: 'Comparison',
    component: () => import(/* webpackChunkName: "swipe" */ '../views/Comparison.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

export default router
